// libraries
import React from 'react'
import { Typography, IconButton } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { RemoveRedEye } from '@mui/icons-material'

// helpers and utils
import { dateTimeFormatter } from 'utils/data-manipulation/valueFormatter'

// specific components
import { batchStatus } from 'components/containers/ledger/utils'
import DataGridWithSearch from './DataGridWithSearch'

const BatchNumberCell = ({ id, batchNumber }) => {
  const navigate = useNavigate()

  return (
    <>
      <IconButton
        color="primary"
        size="small"
        onClick={() => navigate(`/app/ledger/sync-log/${batchNumber}`)}
        sx={{ marginRight: 1 }}
      >
        {id}
        <RemoveRedEye fontSize="small" sx={{ ml: 1 }} />
      </IconButton>
    </>
  )
}

const columns = [
  {
    flex: 2,
    field: 'id',
    headerName: 'Batch #',
    align: 'left',
    renderCell: params => <BatchNumberCell id={params.row.id} batchNumber={params.row.batchNumber} />,
  },
  {
    field: 'dateTime',
    headerName: 'Date/Time',
    flex: 5,
    renderCell: params => dateTimeFormatter(params.row.dateTime, { dateFormatFull: true, reversed: true }),
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 5,
    renderCell: params => (
      <>
        {batchStatus[params.row.status]?.icon()}
        <Typography variant="body2">{batchStatus[params.row.status]?.text}</Typography>
      </>
    ),
  },
  {
    field: 'user',
    headerName: 'User',
    flex: 3,
  },
  // {
  //   field: 'actions',
  //   headerName: '',
  //   align: 'right',
  //   renderCell: () => <MoreVertIcon />,
  // },
]

const LedgerSyncLogGrid = props => (
  <DataGridWithSearch {...props} columns={columns} textSearchPlaceholder="Search for anything" />
)

LedgerSyncLogGrid.propTypes = DataGridWithSearch.propTypes

LedgerSyncLogGrid.defaultProps = DataGridWithSearch.defaultProps

export default LedgerSyncLogGrid
